import InlineText from '@/design_system/Typography/InlineText';
import { createBEMClasses } from '@/utils/classname';
import useViewPort from '@/utils/useViewport';

import Stack from '../Stack';

import './Footer.css';

const { element, block } = createBEMClasses('footer');

export const Footer = ({ children }: { children?: React.ReactNode; className?: string }) => {
  const { isMobile } = useViewPort();

  return (
    <footer
      className={block()}
      style={
        isMobile
          ? { flexDirection: 'column', gap: '1rem', justifyContent: 'center' }
          : { justifyContent: 'space-between', alignItems: 'center' }
      }
    >
      {children}
    </footer>
  );
};

export const FooterButtons = ({
  children,
  variant,
}: {
  children?: React.ReactNode;
  variant?: 'full';
}) => {
  const { isMobile } = useViewPort();

  return (
    <Stack
      className={element('buttons', { variant })}
      style={
        isMobile
          ? { flexDirection: 'column', gap: '0.75rem' }
          : { flex: 1, flexDirection: 'row', gap: '1rem', justifyContent: 'flex-end' }
      }
    >
      {children}
    </Stack>
  );
};

export const FooterError = ({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <Stack className={element('error', undefined, className)} style={{ alignItems: 'center' }}>
      <InlineText color="danger">{children}</InlineText>
    </Stack>
  );
};
